import { ChevronRight } from "@tamagui/lucide-icons";
import { hairline, Paragraph, Paragraph2, TamaguiCard, XStack, YStack } from "@medbillai/ui";
import { Flag } from "@medbillai/utils";
import { useBoolVariation } from "../../../lib/flag";
interface BillsOverviewBannerProps {
  issueOrBillCount?: number;
  onPress: () => void;
  issueType?: "single" | "multiple";
}
const getBannerText = (count: number, issueType: "single" | "multiple"): string => {
  if (issueType === "single") {
    return `${count} potential ${count === 1 ? "issue" : "issues"} with this bill`;
  }
  return `${count} ${count === 1 ? "bill" : "bills"} with possible issues`;
};
export const BillsOverviewBanner = ({
  issueOrBillCount = 0,
  onPress,
  issueType = "multiple"
}: BillsOverviewBannerProps) => {
  const isFindingsEnabled = useBoolVariation(Flag.EOB_FINDINGS_V1_ENABLED, false);
  if (!isFindingsEnabled || issueOrBillCount <= 0) {
    return null;
  }
  return <XStack px={issueType === "single" ? "$4.5" : "$3"} width="100%" justifyContent="center" data-sentry-element="XStack" data-sentry-component="BillsOverviewBanner" data-sentry-source-file="BillsOverviewBanner.tsx">
      <TamaguiCard borderRadius="$6" onPress={onPress} pressStyle={{
      backgroundColor: "$backgroundTertiary",
      scale: 0.97
    }} transition="press" borderWidth={hairline} marginVertical={issueType === "single" ? 0 : "$3"} borderColor="$strokeSecondary" boxShadow="0px 2px 4px rgba(0,0,0,0.07)" width="100%" data-sentry-element="TamaguiCard" data-sentry-source-file="BillsOverviewBanner.tsx">
        <XStack justifyContent="space-between" alignItems="center" paddingVertical="$4" paddingHorizontal="$5" data-sentry-element="XStack" data-sentry-source-file="BillsOverviewBanner.tsx">
          <XStack alignItems="center" gap="$3.5" flex={1} data-sentry-element="XStack" data-sentry-source-file="BillsOverviewBanner.tsx">
            <XStack backgroundColor="$backgroundTertiary" width={42} height={42} borderRadius="$7" alignItems="center" justifyContent="center" data-sentry-element="XStack" data-sentry-source-file="BillsOverviewBanner.tsx">
              <Paragraph size="$6" data-sentry-element="Paragraph" data-sentry-source-file="BillsOverviewBanner.tsx">
                {issueType === "single" ? "💸" : "💵"}
              </Paragraph>
            </XStack>
            <YStack gap="$0.5" data-sentry-element="YStack" data-sentry-source-file="BillsOverviewBanner.tsx">
              <Paragraph bold data-sentry-element="Paragraph" data-sentry-source-file="BillsOverviewBanner.tsx">
                {getBannerText(issueOrBillCount, issueType)}
              </Paragraph>
              <Paragraph2 theme="alt1" data-sentry-element="Paragraph2" data-sentry-source-file="BillsOverviewBanner.tsx">
                Tap to review for potential savings.
              </Paragraph2>
            </YStack>
          </XStack>
          <ChevronRight size="$1" data-sentry-element="ChevronRight" data-sentry-source-file="BillsOverviewBanner.tsx" />
        </XStack>
      </TamaguiCard>
    </XStack>;
};